export const SNS_SHARE_URL = {
  facebook: 'https://www.facebook.com/sharer.php',
  line: 'https://line.me/R/msg/text/',
  twitter: 'https://twitter.com/share',
};
